exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".application{background:rgba(63,81,181,.0705882)!important}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/pages/commerces.vue"],"names":[],"mappings":"AACA,aACE,6CAAoD,CACrD","file":"commerces.vue","sourcesContent":["\n.application {\n  background: rgba(63, 81, 181, 0.0705882) !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f2e9fe6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/commerces.vue
// module id = 784
// module chunks = 17